export enum LikesActionTypes {
  ADD_TO_FAVORITES_REQUEST = '[Likes] ADD_TO_FAVORITES_REQUEST',
  ADD_TO_FAVORITES_SUCCESS = '[Likes] ADD_TO_FAVORITES_SUCCESS',
  ADD_TO_FAVORITES_ERROR = '[Likes] ADD_TO_FAVORITES_ERROR',
}
